var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c(
        "el-card",
        {
          attrs: {
            "body-style": {
              padding: "0px",
            },
          },
        },
        [
          _c(
            "el-card",
            {
              staticStyle: { height: "calc(100vh - 70px)", width: "100%" },
              attrs: {
                "body-style": {
                  padding: "0px 20px",
                  height: "100%",
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    height: "40px",
                    display: "flex",
                    "font-size": "18px",
                    "font-weight": "bold",
                    "align-items": "center",
                  },
                },
                [
                  _c("div", { staticStyle: { color: "#000" } }, [
                    _c(
                      "span",
                      {
                        staticStyle: { cursor: "pointer" },
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "/ProjectInfo/ProjectAll?id=" +
                                _vm.$route.query.id
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.backName || "工作台"))]
                    ),
                    _c("i", { staticClass: "el-icon-arrow-right" }),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "ellipsis",
                      staticStyle: { color: "#606266" },
                    },
                    [_vm._v("设备信息审核")]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.Summarizingloading,
                      expression: "Summarizingloading",
                    },
                  ],
                  staticClass: "headData",
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    width: "100%",
                    height: "110px",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        height: "100%",
                        width: "100%",
                        display: "flex",
                        gap: "20px",
                      },
                      attrs: { gutter: 20 },
                    },
                    [
                      _c(
                        "div",
                        {
                          style: `width:${100 / 5}%;height:100%`,
                          attrs: { span: 4 },
                        },
                        [
                          _c(
                            "el-card",
                            { staticStyle: { width: "100%", height: "110px" } },
                            [
                              _c(
                                "el-statistic",
                                {
                                  attrs: {
                                    value: Math.round(
                                      Number(
                                        _vm.SummarizingInfo.deviceCount || 0
                                      )
                                    ),
                                    "value-style": {
                                      fontSize: "24px",
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { attrs: { slot: "title" }, slot: "title" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-size": "18px",
                                            "font-weight": "bold",
                                            color: "#e6a23c",
                                          },
                                        },
                                        [_vm._v(" 设备数量 ")]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          style: `width:${100 / 5}%;height:100%`,
                          attrs: { span: 4 },
                        },
                        [
                          _c(
                            "el-card",
                            { staticStyle: { width: "100%", height: "110px" } },
                            [
                              _c(
                                "el-statistic",
                                {
                                  attrs: {
                                    value: Math.round(
                                      Number(
                                        _vm.SummarizingInfo.DocumentCount || 0
                                      )
                                    ),
                                    "value-style": {
                                      fontSize: "24px",
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { attrs: { slot: "title" }, slot: "title" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-size": "18px",
                                            "font-weight": "bold",
                                            color: "#e6a23c",
                                          },
                                        },
                                        [_vm._v(" 文档数量 ")]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          style: `width:${100 / 5}%;height:100%`,
                          attrs: { span: 4 },
                        },
                        [
                          _c(
                            "el-card",
                            { staticStyle: { width: "100%", height: "110px" } },
                            [
                              _c(
                                "el-statistic",
                                {
                                  attrs: {
                                    value: Math.round(
                                      Number(
                                        _vm.SummarizingInfo.AccessoryCount || 0
                                      )
                                    ),
                                    "value-style": {
                                      fontSize: "24px",
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { attrs: { slot: "title" }, slot: "title" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-size": "18px",
                                            "font-weight": "bold",
                                            color: "#e6a23c",
                                          },
                                        },
                                        [_vm._v(" 备件数量 ")]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          style: `width:${100 / 5}%;height:100%`,
                          attrs: { span: 4 },
                        },
                        [
                          _c(
                            "el-card",
                            {
                              staticStyle: {
                                width: "100%",
                                height: "100%",
                                position: "relative",
                              },
                              attrs: {
                                "body-style": {
                                  padding: 0,
                                },
                              },
                            },
                            [
                              _c("div", {
                                staticStyle: {
                                  width: "100%",
                                  height: "calc(100%)",
                                  "margin-top": "60px",
                                },
                                attrs: { id: "DeviceProgress" },
                              }),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    height: "30px",
                                    width: "100%",
                                    position: "absolute",
                                    top: "0",
                                    left: "0",
                                    "text-align": "center",
                                    "font-weight": "bold",
                                    "font-size": "18px",
                                    "line-height": "30px",
                                  },
                                },
                                [_vm._v(" 提交率 ")]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          style: `width:${100 / 5}%;height:100%`,
                          attrs: { span: 4 },
                        },
                        [
                          _c(
                            "el-card",
                            {
                              staticStyle: {
                                width: "100%",
                                height: "100%",
                                position: "relative",
                              },
                              attrs: {
                                "body-style": {
                                  padding: 0,
                                },
                              },
                            },
                            [
                              _c("div", {
                                staticStyle: {
                                  width: "100%",
                                  height: "calc(100%)",
                                  "margin-top": "60px",
                                },
                                attrs: { id: "DocumentProgress" },
                              }),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    height: "30px",
                                    width: "100%",
                                    position: "absolute",
                                    top: "0",
                                    left: "0",
                                    "text-align": "center",
                                    "font-weight": "bold",
                                    "font-size": "18px",
                                    "line-height": "30px",
                                  },
                                },
                                [_vm._v(" 通过率 ")]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticStyle: { height: "calc(100% - 130px)" },
                },
                [
                  _c(
                    "el-row",
                    {
                      staticStyle: {
                        height: "40px",
                        display: "flex",
                        "align-items": "center",
                        "margin-top": "10px",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "220px", "margin-right": "10px" },
                        attrs: { placeholder: "供应商名称", clearable: "" },
                        model: {
                          value: _vm.searchValue,
                          callback: function ($$v) {
                            _vm.searchValue = $$v
                          },
                          expression: "searchValue",
                        },
                      }),
                      _c("el-input", {
                        staticStyle: { width: "220px", "margin-right": "10px" },
                        attrs: { placeholder: "设备名称/编号", clearable: "" },
                        model: {
                          value: _vm.DeviceName,
                          callback: function ($$v) {
                            _vm.DeviceName = $$v
                          },
                          expression: "DeviceName",
                        },
                      }),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-right": "10px" },
                          attrs: { type: "primary" },
                          on: { click: _vm.searchData },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "el-radio-group",
                        {
                          staticStyle: { "margin-right": "10px" },
                          on: { change: _vm.searchData },
                          model: {
                            value: _vm.Status,
                            callback: function ($$v) {
                              _vm.Status = $$v
                            },
                            expression: "Status",
                          },
                        },
                        [
                          _c("el-radio-button", { attrs: { label: "" } }, [
                            _vm._v("全部"),
                          ]),
                          _c("el-radio-button", { attrs: { label: 1 } }, [
                            _vm._v("待审核"),
                          ]),
                          _c("el-radio-button", { attrs: { label: 2 } }, [
                            _vm._v("已审核"),
                          ]),
                          _c("el-radio-button", { attrs: { label: 4 } }, [
                            _vm._v("驳回"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        height: "calc(100% - 40px)",
                        "overflow-x": "hidden",
                      },
                    },
                    [
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.tableData,
                            height: "calc(100% - 78px)",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              type: "index",
                              label: "序号",
                              width: "55",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "设备编号",
                              prop: "device_no",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "设备名称",
                              prop: "device_name",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "设备规格",
                              prop: "specification",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "设备数量",
                              prop: "Num",
                              align: "right",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "安装日期",
                              prop: "purchase_date",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "填写人",
                              prop: "cVenName",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "生产厂家名称",
                              prop: "manufacturer",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "维修商名称",
                              prop: "maintenance",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "提交日期",
                              prop: "SubmitTime",
                              width: "130",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm
                                            .moment(scope.row.SubmitTime)
                                            .format("YYYY-MM-DD")
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "Status",
                              label: "状态",
                              align: "center",
                              width: "130",
                              sortable: "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.Status == 1
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "warning" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.Reviewer?.length == 1
                                                  ? "部分审核"
                                                  : "待审核"
                                              ) + " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    scope.row.Status == 2 ||
                                    scope.row.Status == 3
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "success" } },
                                          [_vm._v("已审核 ")]
                                        )
                                      : _vm._e(),
                                    scope.row.Status == 4
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "danger" } },
                                          [_vm._v("驳回 ")]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "审核人",
                              prop: "Reviewer",
                              width: "130",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return _vm._l(
                                    scope.row.Reviewer,
                                    function (item) {
                                      return _c("el-tag", { key: item }, [
                                        _vm._v(_vm._s(item)),
                                      ])
                                    }
                                  )
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "active",
                              label: "操作",
                              width: "130",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text", size: "mini" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleClick(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("详情")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text", size: "mini" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openInfo(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("记录")]
                                    ),
                                    (scope.row.Status == 1 &&
                                      scope.row.Reviewer?.length == 1) ||
                                    scope.row.Status == 2 ||
                                    scope.row.Status == 3 ||
                                    scope.row.Status == 4
                                      ? _c(
                                          "el-button",
                                          {
                                            staticStyle: { color: "#e6a23c" },
                                            attrs: {
                                              type: "text",
                                              size: "mini",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.revocation(scope.row)
                                              },
                                            },
                                          },
                                          [_vm._v("撤销")]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "text-align": "right",
                            height: "40px",
                            display: "flex",
                            "align-items": "center",
                            "justify-content": "right",
                          },
                        },
                        [
                          _c("el-pagination", {
                            attrs: {
                              "current-page": _vm.pagination.PageIndex,
                              "page-sizes": _vm.pagination.PageSizes,
                              "page-size": _vm.pagination.PageRows,
                              layout: "total, sizes, prev, pager, next, jumper",
                              total: _vm.pagination.total,
                            },
                            on: {
                              "size-change": _vm.handleSizeChange,
                              "current-change": _vm.handleCurrentChange,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c("ScheduleView", {
        ref: "ScheduleView",
        on: {
          refresh: () => {
            this.getTableData()
            this.getSummarizingInfo()
          },
        },
      }),
      _c("InfoStatistic", { ref: "InfoStatistic" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }